const mapStateToProps = (state) => {
    const {
        api:{
            documentData,
        }={},
        user:{
            rights,
        }={},

        service:{
            Api:{
                getDocumentData,
                actions:{
                    setDocumentData,
                }={},
            }={}
        }={}
    } = state;
    return {
        documentData,
        rights,
        getDocumentData,
        setDocumentData,
    }
}

export default mapStateToProps;